import React, { useEffect, useState, useRef } from "react";

export function FlashCell({ value, format, className = "" }) {
  const [flash, setFlash] = useState("");
  const prev = useRef(value);
  useEffect(() => {
    if (prev.current === undefined || prev.current === null) {
      prev.current = value;
      return;
    }
    if (value > prev.current) setFlash("flash-up");
    else if (value < prev.current) setFlash("flash-down");
    prev.current = value;
    const t = setTimeout(() => setFlash(""), 700);
    return () => clearTimeout(t);
  }, [value]);
  return <span className={`num ${flash} ${className}`}>{format ? format(value) : value}</span>;
}

export function fmtMoney(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return n.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtPrice(n) {
  if (n === null || n === undefined) return "—";
  if (n < 1) return n.toFixed(5);
  if (n < 100) return n.toFixed(3);
  return n.toFixed(2);
}

export function fmtPct(n) {
  if (n === null || n === undefined) return "—";
  return `${n > 0 ? "+" : ""}${n.toFixed(2)}%`;
}
